module.exports = __webpack_public_path__ + "static/media/whats_app_logo.6989d1ff.png";